export default __webpack_public_path__ + "static/media/call.bc12ce83.png";